import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

export function CRMIcon({ crmType, ...props }) {
  return (
    <Icon
      name="rss"
      className={`${crmType}_color`}
      title={crmType}
      {...props}
    />
  );
}

CRMIcon.propTypes = {
  crmType: PropTypes.string.isRequired,
};

export default CRMIcon;
